<div class="ticket-container">
  <div
    *ngFor="let result of actionResults"
    [ngStyle]="{
      'background-color': isSuccess(result) ? '#c8e6c9' : '#ffcdd2'
    }"
    class="ticket-result"
  >
    <div><strong>ID:</strong> {{ result.ticket.id }}</div>
    <div><strong>Title:</strong> {{ result.ticket.title }}</div>

    <messages
      *ngIf="!isSuccess(result)"
      [messagesObserver]="asObservableMessages(result.messages)"
    ></messages>
  </div>
</div>

<button *ngIf="allTicketsSuccessful" (click)="finish()" class="finish-button">
  {{ "process.finish" | translate }}
</button>
